import { ItCompleteAutomationsState } from '@pages/automation-center/store/states/it-complete-automations.state';
import { ThirdPartyIntegrationsState } from '@pages/automation-center/store/states/third-party-integrations.state';
import { KaseyaPlatformFeaturesState } from '@pages/automation-center/store/states/kaseya-platform-features.state';
import { AutomationsFilterState } from '@pages/automation-center/store/states/automations-filter.state';
import { AutomationsState } from '@pages/automation-center/store/states/automations.state';
import { ThirdPartyIntegrationState } from '@pages/automation-center/store/states/third-party-integration.state';
import { ItCompleteAutomationState } from '@pages/automation-center/store/states/it-complete-automation.state';
import { KaseyaPlatformFeatureDetailsState } from '@pages/automation-center/store/states/kaseya-platform-feature-details.state';
import { SubscriptionModulesState } from '@pages/automation-center/store/states/subscription-modules.state';

export const automationCenterState = [
  AutomationsState,
  AutomationsFilterState,
  ItCompleteAutomationsState,
  ThirdPartyIntegrationsState,
  KaseyaPlatformFeaturesState,
  ThirdPartyIntegrationState,
  ItCompleteAutomationState,
  KaseyaPlatformFeatureDetailsState,
  SubscriptionModulesState,
];
